import React, { useState, useEffect } from 'react';
import { Form } from 'semantic-ui-react';
import { producaov2 as api } from '../../../../services/apis';
import { isAuthAdmin } from "../../../../services/auth";
import swal from "sweetalert";

import {
    StyledLabel,
    StyledButton,
    ContainerDouble,
    ContainerSingle
} from './styles';

const Formulario = () => {
    const [eventoNome, setEventoNome] = useState(null);
    const [eventoEmail, setEventoEmail] = useState(null);
    const [eventoInicioDia, setEventoInicioDia] = useState(null);
    const [eventoInicioHora, setEventoInicioHora] = useState(null);
    const [eventoFinalDia, setEventoFinalDia] = useState(null);
    const [eventoFinalHora, setEventoFinalHora] = useState(null);
    const [eventoURL, setEventoURL] = useState(null);

    useEffect(() => {
        loadAuth();
    }, [])

    const loadAuth = async () => {
        const auth = await isAuthAdmin();

        if (!auth) {
            localStorage.setItem("redirect", `/admin/`);
            window.location.href = "/login";
            return null;
        }
    };

    async function createEvento() {
        const data = {
            titulo: eventoNome,
            data_inicio: `${eventoInicioDia} ${eventoInicioHora}:00`,
            data_final: `${eventoFinalDia} ${eventoFinalHora}:00`,
            url_evento: eventoURL,
            modelo_email: eventoEmail
        }

        await api
            .post(`/eventos`, data)
            .then(res => {
                swal('Sucesso no cadastro!', 'O evento foi criado.', 'success');
            })
            .catch(err => {
                console.error(err);
                swal('Erro no cadastro!', 'Aconteceu algum erro durante a criação.', 'error');
            });
    }

    function generateURL(evento) {
        const auxArray = evento.split(" ");
        let auxText = "";
        let i;
        for (i = 0; i < auxArray.length; i++) {
            auxText += auxArray[i] + "-";
        }
        const url = auxText.substr(0, auxText.length - 1);
        setEventoURL(url);
    }

    async function goToCreateEmail() {
        window.location.href = "/admin/eventos/email";
    }

    return (
        <Form>
            <Form.Field>
                <StyledLabel>Nome do evento</StyledLabel>
                <Form.Input
                    placeholder='Nome do evento'
                    value={eventoNome}
                    onChange={e => {
                        setEventoNome(e.target.value);
                        generateURL(e.target.value);
                    }}
                />
            </Form.Field>
            <Form.Field>
                <StyledLabel>Modelo do e-mail de inscrição</StyledLabel>
                <Form.Input
                    placeholder='Modelo do e-mail'
                    type="number"
                    value={eventoEmail}
                    onChange={e => setEventoEmail(e.target.value)}
                />
            </Form.Field>
            <Form.Field>
                <StyledLabel>Início do evento</StyledLabel>
                <ContainerDouble>
                    <ContainerSingle>
                        <StyledLabel>Dia</StyledLabel>
                        <Form.Input
                            type="date"
                            value={eventoInicioDia}
                            onChange={e => setEventoInicioDia(e.target.value)}
                        />
                    </ContainerSingle>
                    <ContainerSingle>
                        <StyledLabel>Hora</StyledLabel>
                        <Form.Input
                            type="time"
                            value={eventoInicioHora}
                            onChange={e => setEventoInicioHora(e.target.value)}
                        />
                    </ContainerSingle>
                </ContainerDouble>
            </Form.Field>
            <Form.Field>
                <StyledLabel>Fim do evento</StyledLabel>

                <ContainerDouble>
                    <ContainerSingle>
                        <StyledLabel>Dia</StyledLabel>
                        <Form.Input
                            type="date"
                            value={eventoFinalDia}
                            onChange={e => setEventoFinalDia(e.target.value)}
                        />
                    </ContainerSingle>
                    <ContainerSingle>
                        <StyledLabel>Hora</StyledLabel>
                        <Form.Input
                            type="time"
                            value={eventoFinalHora}
                            onChange={e => setEventoFinalHora(e.target.value)}
                        />
                    </ContainerSingle>
                </ContainerDouble>
            </Form.Field>
            <ContainerDouble>
                <StyledButton onClick={createEvento} >
                    <i class="plus icon"></i> Criar evento
                </StyledButton>
                <StyledButton onClick={goToCreateEmail} >
                    <i class="plus icon"></i> Anexar e-mail de premiação
                </StyledButton>
            </ContainerDouble>
        </Form>
    );
}


export default Formulario;